<template>
  <div v-if="currentSession">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Intitulé</span>
                  </td>
                  <td>
                    {{ currentSession.intitule }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date début </span>
                  </td>
                  <td>
                    {{ currentSession.date_debut }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold">
                      Nombre de places disponibles
                    </span>
                  </td>
                  <td>
                    {{ currentSession.nbre_place }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentSession.document.created_by.prenom
                        ? currentSession.document.created_by.prenom +
                          ' ' +
                          currentSession.document.created_by.nom
                        : currentSession.document.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-globe text-custom-primary"></i>
                    <span class="font-weight-bold"> Lieu</span>
                  </td>
                  <td>
                    {{ currentSession.lieu }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date début </span>
                  </td>
                  <td>
                    {{ currentSession.date_fin }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Durée</span>
                  </td>
                  <td>
                    {{ currentSession.duree + ' H' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <b-card class="text-black" header-class="bg-silver">
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cubes"></i> Description
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12 text-dark lead" style="color: black">
                <p
                  v-if="currentSession.description"
                  v-html="currentSession.description"
                ></p>
                <p v-else>Pas de description</p>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters('formationSession', ['currentSession']),
  },
};
</script>

<style scoped></style>
